<div class="avatar">
    <span class="numerator">
        <ng-content select="[numerator]" ></ng-content>
    </span>
    <span *ngIf="line">/</span>
    <span class="denominator">
        <ng-content select="[denominator]" ></ng-content>
    </span>
</div>